import React from 'react'
import { BsInstagram } from 'react-icons/bs';
import { HiMail } from 'react-icons/hi';
import { ImLocation } from 'react-icons/im';
import { FcPhoneAndroid } from 'react-icons/fc';
import { IoLogoWhatsapp } from 'react-icons/io';

function FooterComponent() {
    return (
        <footer className='footerComponent' id='Contact'>
            <div className="container pt-5 pb-4">
                <div className="row">
                    <div className='footer d-lg-flex justify-content-evenly pb-4'>
                        <div className="col-lg-5 col-12 mb-4 mb-lg-0">
                            <h3 className='mb-3'>Mehandi Malabar</h3>
                            <p>Mehandi enthusiast, crafting beauty with henna's embrace.<br />
                                Passionate about the art, creating timeless designs.<br />
                                Let's celebrate tradition and elegance through mehandi.<br />
                                Join me on this artistic journey of self-expression.</p>
                            <div className="d-flex align-items-center gap-3 mt-3">
                                <span style={{ width: 50, height: 1, background: 'rgba(201,169,110,0.4)', display: 'block' }}></span>
                                <a href="https://www.instagram.com/mehandi_malabar/?igshid=MzRlODBiNWFlZA%3D%3D"
                                    target="_blank" rel="noopener noreferrer">
                                    <BsInstagram className='instaIcon' />
                                </a>
                                <span style={{ width: 50, height: 1, background: 'rgba(201,169,110,0.4)', display: 'block' }}></span>
                            </div>
                        </div>

                        <div className="col-lg-2 col-6 mb-4 mb-lg-0">
                            <h4 className='mb-3'>Services</h4>
                            <div className='d-flex flex-column gap-2'>
                                <span>Bridal Mehandi</span>
                                <span>Traditional Mehandi</span>
                                <span>Arabic Mehandi</span>
                                <span>Indian Mehandi</span>
                            </div>
                        </div>

                        <div className="col-lg-2 col-6 mb-4 mb-lg-0">
                            <h4 className='mb-3'>Quick Links</h4>
                            <div className='d-flex flex-column gap-2'>
                                <a href="/">Home</a>
                                <a href="/about">About Artist</a>
                                <a href="/gallery">Gallery</a>
                                <a href="/contact">Contact</a>
                            </div>
                        </div>

                        <div className="col-lg-3 col-12">
                            <h4 className='mb-3'>Get In Touch</h4>
                            <div className='d-flex flex-column gap-2'>
                                <p className='mb-1'><FcPhoneAndroid className='me-2' /> (+91) 9539100636</p>
                                <p className='mb-1'><IoLogoWhatsapp className='me-2 greenWhatsapp' /> (+91) 9061672817</p>
                                <p className='mb-1'><HiMail className='me-2' style={{ color: '#EA4335' }} /> mahandimalabar@gmail.com</p>
                                <p className='mb-1'><ImLocation className='me-2 text-danger' /> Kondotty, Malappuram</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row border-top pt-3 mt-2" style={{ borderColor: 'rgba(201,169,110,0.2) !important' }}>
                    <div className="col text-center">
                        <p className="mb-0" style={{ fontSize: '13px', color: '#9A8070', letterSpacing: '0.5px' }}>
                            © {new Date().getFullYear()} Mehandi Malabar. All rights reserved. Crafted with love in Malappuram, Kerala.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default FooterComponent
